import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { Util } from '@/utils/util';
import { DocumentModel } from '@/store/document.model';
import { ColaboradorService } from '@services/colaborador.service';
import { ArchivoService } from '@services/archivo.service';


@Component({
  selector: 'app-form-document',
  templateUrl: './form-document.component.html',
  styleUrls: ['./form-document.component.scss']
})
export class FormDocumentComponent {

  displayedColumnsDocumentos: string[] = [
    'item',
    'nombreDocumento',
    'options'
  ];

  listaDocument: DocumentModel[] = [];

  dataSourceDocumentos =
    new MatTableDataSource<DocumentModel>();

  @ViewChild(MatPaginator)
  paginatorDocumentos!: MatPaginator;

  @ViewChild(MatSort)
  sortDocumentos!: MatSort;

  constructor(
    private util: Util,
    private colaboradorService: ColaboradorService,
    private archivoService: ArchivoService,
    public dialogRef: MatDialogRef<FormDocumentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    console.log( this.data.id_colaborador)
    this.cargarDocument();
  }

  ngAfterViewInit(): void {
    this.dataSourceDocumentos.paginator =
      this.paginatorDocumentos;

    this.dataSourceDocumentos.sort =
      this.sortDocumentos;
  }

  initTableDocument(): void {

    this.dataSourceDocumentos =
      new MatTableDataSource(
        this.listaDocument.filter(x => !x.delete)
      );

    this.dataSourceDocumentos.sort =
      this.sortDocumentos;

    this.dataSourceDocumentos.paginator =
      this.paginatorDocumentos;
  }

  cargarDocument(): void {

    this.listaDocument = [];

    this.colaboradorService
      .getDocuments({
        id_colaborador:
          this.data.id_colaborador
      })
      .subscribe({
        next: (response: any) => {
          this.listaDocument = response ?? [];

          this.initTableDocument();
        },
        error: () => {

          this.util.errorMessage(
            'Error al obtener los documentos.'
          );

        }
      });
  }

  downloadDocument(row: DocumentModel): void {

    if (!row.id_documento ||
      row.id_documento <= 0) {

      this.util.errorMessage(
        'El documento no ha sido guardado.'
      );

      return;
    }

    this.archivoService
      .descargarYGuardarArchivo(
        'documento',
        row.id_documento,
        row.nombre
      );
  }

  close(): void {
    this.dialogRef.close();
  }

}